export default "__VITE_ASSET__BQyIy523__"